import { useNavigate, useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { OwnerParams } from 'shared/types';
import { buildEditVisitPath } from 'utils/route-helpers';

export const useEditVisitAction = (visitId: string) => {
  const navigate = useNavigate();
  const ownerParams = useParams<OwnerParams>();

  return useCallback(() => {
    const editPath = buildEditVisitPath(ownerParams as OwnerParams, visitId);
    navigate(editPath);
  }, [navigate, ownerParams, visitId]);
};
